<script>
import MixedGridVideoItem from '@phoenix/mixins/components/mixedGrid/MixedGridVideoItem';
import BackgroundVideo from '@maison/components/molecules/BackgroundVideo';

export default {
  components: {
    BackgroundVideo,
  },

  mixins: [MixedGridVideoItem],

  computed: {
    containerClasses() {
      return ['mixed-grid-card', { 'mixed-grid-card--large': this.size === 2 }].concat(this.displayClasses);
    },
  },

  methods: {
    initVideo() {
      /**
       * Override and disregard PHX MixedGridVideoItem mixin method as
       * the JLC BackgroundVideo component currently handles this.
       */
    },
  },
};
</script>

<template>
  <div :class="containerClasses">
    <div class="mixed-grid-card__picture">
      <background-video :video-id="itemId" :video-src="video" :poster-src="poster" :source-type="sourceType" />
    </div>
  </div>
</template>
